const Statistics = () => {
  return <div>Statistics</div>;
};

export default Statistics;
